import { render, staticRenderFns } from "./weatherWidget.vue?vue&type=template&id=518e1d3c&"
import script from "./weatherWidget.vue?vue&type=script&lang=js&"
export * from "./weatherWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports